import { CreditScoreGraph } from "shared/app/CreditScoreGraph";
import {
  CreditReportModels,
  CreditReportModelsNumbers,
  CreditReportModelsNumbersToNames
} from "shared/types";
import { Section } from "views/applications-id-report/components/Section";
import { AlertCircleIcon } from "@hugeicons-pro/core-solid-rounded";
import { HugeiconsIcon } from "@hugeicons/react";
import { ReasonCodes, ScoreReasonCodes } from "../utils";
import { InsufficientCreditScore } from "./InsufficientCreditScore";

interface CreditScoreProps {
  score: number;
  isNoHit: boolean;
  isInsufficientData?: boolean;
  model_number?: string;
  score_reason?: string | null;
}

const getScoreReasonMessage = (score: number, score_reason?: string | null) => {
  if (score_reason)
    return (
      ScoreReasonCodes[score_reason as keyof typeof ScoreReasonCodes] ||
      score_reason
    );
  if (score === 1) return ScoreReasonCodes[ReasonCodes.INSUFFICIENT_DATA];
  if (score < 300 || score > 850)
    return ScoreReasonCodes[ReasonCodes.OUT_OF_RANGE];

  return null;
};

export const CreditScore = ({
  score,
  isNoHit,
  isInsufficientData,
  model_number,
  score_reason
}: CreditScoreProps) => {
  if (isNoHit || isInsufficientData)
    return (
      <Section
        sectionTitle={`Credit score (${model_number && CreditReportModelsNumbersToNames[model_number] ? CreditReportModelsNumbersToNames[model_number] : CreditReportModelsNumbersToNames[CreditReportModelsNumbers[CreditReportModels.VantageScore]]})`}
        maxWidth="none"
      >
        <p className="text-base font-medium text-content-300">
          No data available
        </p>
      </Section>
    );

  const scoreReasonMessage = getScoreReasonMessage(score, score_reason);

  return (
    <Section
      sectionTitle={`Credit score (${model_number && CreditReportModelsNumbersToNames[model_number] ? CreditReportModelsNumbersToNames[model_number] : CreditReportModelsNumbersToNames[CreditReportModelsNumbers[CreditReportModels.VantageScore]]})`}
      maxWidth="none"
    >
      <p className="pb-1 text-sm font-medium text-content-1000">Credit score</p>
      <p className="pb-4 text-3xl font-bold text-content-1000 border-b border-alpha-40">
        {score === 1 ? <InsufficientCreditScore /> : score || "-"}
      </p>

      {scoreReasonMessage ? (
        <div className="flex items-center gap-3 py-6">
          <HugeiconsIcon
            icon={AlertCircleIcon}
            size={20}
            className="text-warning-600 shrink-0"
          />
          <p className="font-bold">{scoreReasonMessage}</p>
        </div>
      ) : (
        <div className="pt-8">
          <CreditScoreGraph score={score} tooltipSize="L" />
        </div>
      )}
    </Section>
  );
};
